<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="user !== null">

    <div class="p-grid p-mb-4">
      <div class="p-col-6">
        <h2>{{ t('common.labels.procedures') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
        <button [withRight]="editRight" *ngIf="loading !== true && user.showAdditionalData()" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <app-loader [loading]="loading"></app-loader>

    <ng-container *ngIf="loading !== true">

      <p-table
        styleClass="p-datatable-sm"
        [value]="templates"
        [paginator]="true"
        [rows]="20"
        stateStorage="local"
        stateKey="user-templates-list"
        [rowsPerPageOptions]="rowsPerPage"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="t('common.labels.current_page_report')"
      >

        <ng-template pTemplate="colgroup">
          <colgroup>
              <col style="width:30%">
              <col style="width:90px">
              <col style="width:90px">
              <col *ngIf="showPriority()" style="width:90px">
              <col *ngIf="showTags()">
              <col *ngIf="showNotes()">
          </colgroup>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
              <th>{{ t('common.labels.procedure') }}</th>
              <th>{{ t('common.labels.onsite') }}</th>
              <th>{{ t('common.labels.virtual') }}</th>
              <th *ngIf="showPriority()">{{ t('common.labels.priority') }}</th>
              <th *ngIf="showTags()">{{ t('common.labels.tags') }}</th>
              <th *ngIf="showNotes()">{{ t('common.labels.notes') }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-template>
            <tr tabindex="0">
              <td [ngClass]="{inactive: template.control_onsite.value !== true && template.control_virtual.value !== true}">{{ template.name }}</td>
              <td>
                <app-form-control [cid]="template.name + '_onsite'" [control]="template.control_onsite" [type]="'checkbox'" [edit]="inEdit" [basevalue]="template.control_onsite.value" [noMargin]="true" [showLabel]="false"></app-form-control>
              </td>
              <td>
                <app-form-control [cid]="template.name + '_virtual'" [control]="template.control_virtual" [type]="'checkbox'" [edit]="inEdit" [basevalue]="template.control_virtual.value" [noMargin]="true" [showLabel]="false"></app-form-control>
              </td>
              <td *ngIf="showPriority()">
                <app-form-control [cid]="template.name + '_prio'" [control]="template.control_prio" [type]="'select'" [options]="priorities" [edit]="inEdit" [basevalue]="template.control_prio.value" [noMargin]="true" [showLabel]="false" [showPlaceholder]="false"></app-form-control>
              </td>
              <td *ngIf="showTags()">
                <app-form-control *ngIf="template.tags?.length > 0" [cid]="template.name + '_tags'" [control]="template.control_tags" [type]="'multiselect'" [options]="template.tags" [edit]="inEdit" [basevalue]="template.control_tags.value | arrayToList" [noMargin]="true" [showLabel]="false" [showPlaceholder]="false" [showClear]="true"></app-form-control>
                <p *ngIf="!template.tags || template.tags?.length === 0" class="inactive">{{ t('user_templates.messages.no_tags') }}</p>
              </td>
              <td *ngIf="showNotes()">
                {{ template.settings?.note }}
              </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="6">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>

    </ng-container>

  </form>
</ng-container>
